import React from 'react';
import { motion } from 'framer-motion';
import { JaliDivider } from './JaliDivider';
import { useLanguage } from '../lib/LanguageContext';
export function OurVision() {
  const {
    t,
    tArray
  } = useLanguage();
  const phases = tArray<{
    num: string;
    title: string;
    desc: string;
  }>('ourVision.phases');
  return <section className="py-24 md:py-32 bg-ivory relative" data-id="element-145">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-146">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center max-w-3xl mx-auto mb-20" data-id="element-147">
          <h2 className="text-3xl md:text-5xl font-heading text-navy mb-4" data-id="element-148">
            {t('ourVision.title')}
          </h2>
          <p className="text-saffron tracking-widest uppercase text-sm font-medium mb-6" data-id="element-149">
            {t('ourVision.subtitle')}
          </p>
        </motion.div>

        <div className="relative" data-id="element-150">
          {/* Connecting Line */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-[1px] bg-gold/20 -translate-y-1/2 z-0" data-id="element-151" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-152">
            {phases.map((phase, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.8,
            delay: idx * 0.2
          }} className="bg-ivory border border-gold/20 p-8 rounded-sm text-center relative group hover:border-saffron/50 transition-colors duration-500" data-id="element-153">
                {/* Number Badge */}
                <div className="w-16 h-16 mx-auto bg-marble border border-gold/30 rounded-full flex items-center justify-center mb-6 -mt-16 group-hover:-translate-y-2 transition-transform duration-500 shadow-sm" data-id="element-154">
                  <span className="font-heading text-2xl text-saffron" data-id="element-155">
                    {phase.num}
                  </span>
                </div>

                <h3 className="font-heading text-2xl text-navy mb-4" data-id="element-156">
                  {phase.title}
                </h3>
                <p className="text-navy/70 leading-relaxed text-sm" data-id="element-157">
                  {phase.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>

      <JaliDivider className="absolute bottom-0 left-0 translate-y-1/2" data-id="element-158" />
    </section>;
}